export default __webpack_public_path__ + "static/media/products_311.cf164385.jpg";